import { Checkbox, Field, NumericInput, TextOutput } from 'Components/Core';
import {
  WorksheetBatchUpdateEquipmentDisplayField,
  WorksheetBatchUpdateEquipmentSelectionField,
} from 'Components/WorksheetBatchUpdate/Core';
import { WorksheetBatchUpdateWorksheetFieldSection } from 'Components/WorksheetBatchUpdate/types';
import { FormatTypes } from 'Lib/Format';
import { WorksheetBatchUpdateWorksheetField } from '../.';

export const AsDynamicConePenetrometerWorksheetSections: {
  [name: string]: WorksheetBatchUpdateWorksheetFieldSection;
} = {
  preparation: {
    heading: 'Preparation',
  },
  results: {
    heading: 'Results',
  },
};

export const AsDynamicConePenetrometerWorksheetFields: {
  [name: string]: WorksheetBatchUpdateWorksheetField;
} = {
  'data.Preparation.DynamicConePenetrometer': {
    displayComponent: <WorksheetBatchUpdateEquipmentDisplayField />,
    entryComponent: <WorksheetBatchUpdateEquipmentSelectionField equipmentType="dynamic-cone-penetrometer" />,
    isImportSource: true,
    section: 'preparation',
  },
  'data.Preparation.Measure': {
    displayComponent: <WorksheetBatchUpdateEquipmentDisplayField />,
    entryComponent: <WorksheetBatchUpdateEquipmentSelectionField equipmentType="measure" />,
    isImportSource: true,
    section: 'preparation',
  },
  'data.Preparation.MeasurementAtZeroBlows': {
    displayComponent: <Field input={<TextOutput />} />,
    entryComponent: <Field input={<NumericInput />} />,
    displayFieldsWhenEntered: ['data.Results.StartDepth', 'data.Results.FinalDepth'],
    section: 'preparation',
  },

  'data.Preparation.ReducedLevelToLayer': {
    displayComponent: <Field input={<TextOutput />} />,
    entryComponent: <Field input={<NumericInput />} />,
    section: 'preparation',
  },

  'data.Preparation.SurfaceLevelToLayer': {
    displayComponent: <Field input={<TextOutput />} />,
    entryComponent: <Field input={<NumericInput />} />,
    displayFieldsWhenEntered: ['data.Results.StartDepth', 'data.Results.FinalDepth'],
    section: 'preparation',
  },

  'data.Results.JoinLayersOnChart': {
    displayComponent: <Field input={<TextOutput />} format={{ type: FormatTypes.YesNo }} />,
    entryComponent: <Field input={<Checkbox />} />,
    defaultValue: true,
    section: 'results',
  },

  'data.Results.PenetrationResistanceCheck': {
    displayComponent: <Field input={<TextOutput />} format={{ type: FormatTypes.YesNo }} />,
    entryComponent: <Field input={<Checkbox />} />,
    section: 'results',
  },

  'data.Results.StartDepth': {
    displayComponent: <Field input={<TextOutput />} />,
  },

  'data.Results.FinalDepth': {
    displayComponent: <Field input={<TextOutput />} />,
  },
};

export default AsDynamicConePenetrometerWorksheetFields;
